export const getParams = () => {
  return Object.fromEntries(new URLSearchParams(window.location.search));
};
export const getProjectIdFromUrl = () => {
  const pathParts = window.location.pathname.split("/");
  const projectIndex = pathParts.indexOf("projects");
  if (projectIndex !== -1 && pathParts[projectIndex + 1]) {
    return pathParts[projectIndex + 1];
  }
  return null;
};

export const extractHost = (urlOrHost) => {
  let host;

  if (urlOrHost.includes("http")) {
    try {
      const url = new URL(urlOrHost);
      host = url.hostname;
    } catch (e) {
      host = urlOrHost;
    }
  } else {
    host = urlOrHost;
  }
  return host.replace(/^www\./, "");
};
